import React from "react";
import {DashboardCell} from "./base/DashboardCell";

export class DashboardValueWithAlertCell extends DashboardCell {
    alertCssClasses() {
        let cssClasses = "";
        if (this.props.data.alert_snoozed) {
            cssClasses = '-snoozed';
        }

        if (this.props.data.alert_level !== 'normal') {
            cssClasses = `${cssClasses} alert -${this.props.data.alert_level}`;
        } else {
            cssClasses = `${cssClasses} no-alert`;
        }

        return cssClasses;
    }

    renderCellValue() {
        return this.props.data.formatted_value;
    }

    renderTooltip() {
        return null;
    }

    render() {
        return (
            <td className={`${this.alertCssClasses()} single-data ${this.processingCssClasses()}`}>
                {this.renderCellValue()}
                {this.renderTooltip()}
            </td>
        )
    }
}
